var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanFeature2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87981",
    "data-name": "Group 87981",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.223,
    height: 24.69,
    viewBox: "0 0 24.223 24.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25572",
    "data-name": "Rectangle 25572",
    width: 24.223,
    height: 24.69,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87980",
    "data-name": "Group 87980",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308231",
    "data-name": "Path 308231",
    d: "M14.635,14.234V13.143a.739.739,0,0,1,.739-.739H16.1V2.376L.266,2.384l0,20.609H16.1V14.234Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25571",
    "data-name": "Rectangle 25571",
    width: 1.056,
    height: 20.608,
    transform: "translate(0.265 2.384)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308232",
    "data-name": "Path 308232",
    d: "M9.515,22.635a.357.357,0,1,1-.357.357.357.357,0,0,1,.357-.357",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308233",
    "data-name": "Path 308233",
    d: "M4.258,19.958H2.423a.264.264,0,1,1,0-.528H4.258a.264.264,0,0,1,0,.528",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308234",
    "data-name": "Path 308234",
    d: "M4.258,17.847H2.423a.264.264,0,1,1,0-.528H4.258a.264.264,0,1,1,0,.528",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308235",
    "data-name": "Path 308235",
    d: "M4.258,15.735H2.423a.264.264,0,1,1,0-.528H4.258a.264.264,0,0,1,0,.528",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308236",
    "data-name": "Path 308236",
    d: "M5.659,8.13a3.272,3.272,0,0,0-3.284,3.261V12.8H8.943V11.391A3.272,3.272,0,0,0,5.659,8.13",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308237",
    "data-name": "Path 308237",
    d: "M6.187,8.173a3.288,3.288,0,0,0-3.812,3.218V12.8H3.431V11.391A3.268,3.268,0,0,1,6.187,8.173Z",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308238",
    "data-name": "Path 308238",
    d: "M8.569,9.879a3.232,3.232,0,0,0-.4-.588.422.422,0,0,0-.644.545l.031.037q.038.047.072.093l.261.354a.4.4,0,0,0,.587.068A.414.414,0,0,0,8.569,9.879Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308239",
    "data-name": "Path 308239",
    d: "M5.659,4.512A2.174,2.174,0,1,1,3.47,6.686,2.181,2.181,0,0,1,5.659,4.512",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308240",
    "data-name": "Path 308240",
    d: "M4.525,6.686a2.177,2.177,0,0,1,1.662-2.11,2.174,2.174,0,1,0,0,4.22,2.177,2.177,0,0,1-1.662-2.11",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308241",
    "data-name": "Path 308241",
    d: "M5.659,10.884a.317.317,0,1,1-.317.317.317.317,0,0,1,.317-.317",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308242",
    "data-name": "Path 308242",
    d: "M12.934,11.235H11.1a.264.264,0,1,1,0-.528h1.835a.264.264,0,0,1,0,.528",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308243",
    "data-name": "Path 308243",
    d: "M13.99,9.124H11.1a.264.264,0,1,1,0-.528H13.99a.264.264,0,0,1,0,.528",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308244",
    "data-name": "Path 308244",
    d: "M13.99,7.012H11.1a.264.264,0,1,1,0-.528H13.99a.264.264,0,0,1,0,.528",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308245",
    "data-name": "Path 308245",
    d: "M23.414,15.293H11.441v8.394a.739.739,0,0,0,.739.74H22.675a.739.739,0,0,0,.739-.74Z",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308246",
    "data-name": "Path 308246",
    d: "M12.5,23.687V15.293H11.441v8.394a.739.739,0,0,0,.739.739h1.056A.739.739,0,0,1,12.5,23.687Z",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308247",
    "data-name": "Path 308247",
    d: "M23.414,23.212V21.047a.475.475,0,1,0-.95,0V23a.475.475,0,0,1-.475.475H20.045a.475.475,0,0,0,0,.95H22.2A1.214,1.214,0,0,0,23.414,23.212Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308248",
    "data-name": "Path 308248",
    d: "M18.008,17.772H16.847a.739.739,0,0,0-.739.739v1.161a.738.738,0,0,0,.739.739h1.161a.739.739,0,0,0,.739-.739V18.511a.739.739,0,0,0-.739-.739",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308249",
    "data-name": "Path 308249",
    d: "M16.847,17.772a.739.739,0,0,0-.739.739v1.161a.739.739,0,0,0,.739.739h.317V17.772Z",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308250",
    "data-name": "Path 308250",
    d: "M23.219,13.97H20.484v-.827a1,1,0,0,0-1-1H18.476V.264A.267.267,0,0,0,18.211,0L2.377.008a.264.264,0,0,0-.264.264V2.119H.265A.264.264,0,0,0,0,2.384V22.992a.268.268,0,0,0,.077.187.264.264,0,0,0,.187.077H7.971a.264.264,0,0,0,0-.528H.528V2.648L15.836,2.64v9.5h-.463a1,1,0,0,0-1,1v.827H11.635a1,1,0,0,0-1,1v.234H6.714a.264.264,0,1,0,0,.528h3.918v1.584H6.714a.264.264,0,1,0,0,.528h4.018a1,1,0,0,0,.445.457v1.127H6.714a.264.264,0,1,0,0,.527h4.463v3.729a1,1,0,0,0,1,1H22.675a1,1,0,0,0,1-1V18.3a1,1,0,0,0,.544-.892V14.973A1,1,0,0,0,23.219,13.97ZM14.9,13.143a.476.476,0,0,1,.475-.476h4.108a.476.476,0,0,1,.475.476v.827H14.9Zm3.585,5.368v1.162a.475.475,0,0,1-.475.475H16.847a.476.476,0,0,1-.476-.475V18.511a.476.476,0,0,1,.476-.475h1.161a.475.475,0,0,1,.475.475m4.667,5.176a.475.475,0,0,1-.475.475h-10.5a.476.476,0,0,1-.475-.475v-5.2a19.25,19.25,0,0,0,4.139.8v.383a1,1,0,0,0,1,1h1.162a1,1,0,0,0,1-1v-.384a19.192,19.192,0,0,0,4.139-.8Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308251",
    "data-name": "Path 308251",
    d: "M7.449,8.351a2.421,2.421,0,0,0,.663-1.665,2.454,2.454,0,0,0-4.907,0,2.422,2.422,0,0,0,.664,1.665,3.518,3.518,0,0,0-1.758,3.04V12.8a.264.264,0,0,0,.264.264H8.943a.264.264,0,0,0,.264-.264V11.391a3.52,3.52,0,0,0-1.758-3.04M3.733,6.686A1.914,1.914,0,0,1,4.99,4.9,2.463,2.463,0,0,0,7.566,6.945a1.926,1.926,0,0,1-3.833-.259M8.679,12.54H7.714V11.525a.264.264,0,0,0-.528,0V12.54H4.139V11.525a.264.264,0,0,0-.528,0V12.54H2.639V11.391A3,3,0,0,1,4.3,8.716a2.448,2.448,0,0,0,1.093.394v1.021a.264.264,0,1,0,.528,0V9.11a2.448,2.448,0,0,0,1.093-.394,3,3,0,0,1,1.663,2.675Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanFeature2);
export default __webpack_public_path__ + "static/media/Plan_Feature_2.7be3665e4dca11b2d8a886be76fa7f3f.svg";
export { ForwardRef as ReactComponent };